var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMorArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.971,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.17593 3.30055C7.91933 3.2755 7.68496 3.33409 7.47281 3.47633C5.48714 5.46199 3.50144 7.4477 1.51578 9.43336C1.2814 9.79793 1.2814 10.1625 1.51578 10.5271C3.52855 12.5529 5.55332 14.5646 7.59 16.5623C8.18824 16.8001 8.61144 16.6243 8.85953 16.0349C8.90675 15.7855 8.86769 15.5511 8.74234 15.3318C7.25144 13.8409 5.76058 12.35 4.26968 10.8591C9.17855 10.8461 14.0874 10.8331 18.9962 10.8201C19.6038 10.6404 19.8186 10.2433 19.6408 9.62867C19.5164 9.34824 19.3016 9.18547 18.9962 9.14039C14.0874 9.12738 9.17855 9.11434 4.26968 9.10133C5.74753 7.62348 7.22543 6.14559 8.70328 4.66773C9.01453 4.01902 8.83875 3.56328 8.17593 3.30055Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMorArrow);
export default __webpack_public_path__ + "static/media/MorArrow.8b212f97ea744006a302866ea4d7be77.svg";
export { ForwardRef as ReactComponent };